<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Productos</h4>
            <div class="small text-muted">Administración general de los productos</div>
          </b-col>
          <b-col cols="auto" class="d-flex align-items-center">
            <WidgetVisibilityConfig
              :widgets="widgetsMeta"
              :hidden="hiddenWidgets"
              :disabled="!visibilityLoaded"
              :locked="editingLocked"
              @toggle="onToggleWidget"
              @reset="resetWidgetsVisibility"
              @toggle-lock="setEditingLocked($event)"
            />
            <ChangelogWidget moduleKey="products" :limit="5" />
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col md="9">
          <WidgetMasonry
            v-if="visibilityLoaded"
            v-model="widgetsOrdered"
            :disabled="!visibilityLoaded || editingLocked"
            @order-end="saveWidgetOrder"
            @resize-end="commitWidgetSize"
          >
            <template v-slot:default="{ item }">
                <Widget
                  :configWidget="configWidget"
                  :reference="item.reference"
                  :hasAccess="item.hasAccess"
                  :allowHide="!editingLocked"
                  :allowDrag="!editingLocked"
                  :allowResize="!editingLocked"
                  @hide-widget="hideWidget"
                />
            </template>
          </WidgetMasonry>
        </b-col>  
        <b-col md="3">        
          
          <b-list-group class="mb-1" v-if="!parameters.haveMarketplace && configSubView.elements.products">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openProducts()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Productos</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de productos y todas sus variedades 
              </p>
            </b-list-group-item>
          </b-list-group> 

          <b-list-group class="mb-1" v-if="!parameters.haveMarketplace && isContents && configSubView.elements.products_web">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openProductsWeb()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Productos en Sitio Web</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de productos para mostrar en el sitio web
              </p>
            </b-list-group-item>
          </b-list-group>           

          <b-list-group class="mb-1" v-if="parameters.haveMarketplace && configSubView.elements.products_marketplace">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openMarketplace()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Marketplace</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de productos de marketplace
              </p>
            </b-list-group-item>
          </b-list-group>   
          
          <b-list-group class="mb-1" v-if="parameters.haveProductsCompound && configSubView.elements.products_compound">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openProductsCompound()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Productos Compuestos</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de productos compuestos
              </p>
            </b-list-group-item>
          </b-list-group>                           
        
          <b-list-group class="mb-1" v-if="configSubView.elements.categories">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openCategories()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Categorias</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de categorias y sub-categorias
              </p>
            </b-list-group-item>
          </b-list-group> 

          <b-list-group class="mb-1" v-if="parameters.haveLines && configSubView.elements.lines"> 
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openLines()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Lineas</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de linea y sub-lineas
              </p>
            </b-list-group-item>
          </b-list-group>         

          <b-list-group class="mb-1" v-if="parameters.haveColors && configSubView.elements.colors">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openColors()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Colores</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de colores
              </p>
            </b-list-group-item>
          </b-list-group>            

          <b-list-group class="mb-1" v-if="parameters.haveWaist && configSubView.elements.waist">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openWaist()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Talles</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de talles
              </p>
            </b-list-group-item>
          </b-list-group> 

          <b-list-group class="mb-1" v-if="!parameters.haveMarketplace && parameters.haveUnitMeasurement && configSubView.elements.unit_measurement">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openUnitMeasurement()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Unidades de Medidas</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de unidades de medidas
              </p>
            </b-list-group-item>
          </b-list-group> 

          <b-list-group class="mb-1" v-if="parameters.haveMarketplace && configSubView.elements.contact_sold">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openContactSold()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Productos Vendidos</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Listado de productos que terminaron en ventas
              </p>
            </b-list-group-item>
          </b-list-group>      

          <hr v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
          <b-list-group class="mt-2" v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
            <b-list-group-item v-for="item in arr.PHPCustom" :key="item.id" href="#" class="flex-column align-items-start" @click="openPHPCustom(item)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{item.name}}</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                {{item.observations}}
              </p>
            </b-list-group-item>
          </b-list-group>               
        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import WidgetVisibilityConfig from '@/components/inc/widget/WidgetVisibilityConfig'
  import WidgetMasonry from '@/components/inc/widget/WidgetMasonry'
  import DashboardWidgetsHelper from '@/components/inc/widget/DashboardWidgetsHelper'
import ChangelogWidget from '@/components/inc/changelog/ChangelogWidget'
  import Param from '@/config/parameters'
  import ServicesPHP from '@/components/modules/users/php/staff/services'

  export default {
    mixins: [DashboardWidgetsHelper],
    components: {
      Widget,
      WidgetVisibilityConfig,
      WidgetMasonry,
      ChangelogWidget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PRODUCTOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },        
        configWidget: {
          module_id: Modules.PRODUCTOS,
          profile_id: Profiles.PERSONAL,
          elements: {}
        },
        configSubView: {
          module_id: Modules.PRODUCTOS,
          profile_id: Profiles.PERSONAL,
          elements: {
            products: true,
            products_web: true,
            products_marketplace: true,
            products_compound: true,
            categories: true,
            lines: true,
            colors: true,
            waist: true,
            unit_measurement: true,
            contact_sold: true,
            php_custom: true,
          }
        },           
        parameters: {
          haveLines: Helper.hasParametersAccess(Param.P7),
          haveColors: Helper.hasParametersAccess(Param.P8),
          haveWaist: Helper.hasParametersAccess(Param.P9),
          haveMarketplace: Helper.hasParametersAccess(Param.P18),
          haveProductsCompound: Helper.hasParametersAccess(Param.P30),
          haveUnitMeasurement: Helper.hasParametersAccess(Param.P31),
        },           
        primaryColor: '',
        arr: {
          PHPCustom: []
        },
        modulesActive: null,
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
      this.initDashboardWidgets()

      /* Configurar permisos de las sub vistas */
      this.configSubView.elements.products = Helper.showAccessView(this.configSubView, 'crudProducts')      
      this.configSubView.elements.products_web = Helper.showAccessView(this.configSubView, 'crudProductsWeb')      
      this.configSubView.elements.products_marketplace = Helper.showAccessView(this.configSubView, 'crudProductsMarketplace')      
      this.configSubView.elements.products_compound = Helper.showAccessView(this.configSubView, 'crudProductsCompound')      
      this.configSubView.elements.categories = Helper.showAccessView(this.configSubView, 'crudCategories')      
      this.configSubView.elements.lines = Helper.showAccessView(this.configSubView, 'crudItems')  
      this.configSubView.elements.colors = Helper.showAccessView(this.configSubView, 'crudColors')      
      this.configSubView.elements.waist = Helper.showAccessView(this.configSubView, 'crudWaist')      
      this.configSubView.elements.unit_measurement = Helper.showAccessView(this.configSubView, 'crudUnitMeasurement')  
      this.configSubView.elements.contact_sold = Helper.showAccessView(this.configSubView, 'summaryContactSold')  
      this.configSubView.elements.php_custom = Helper.showAccessPHPCustom()
      /* Fin configuracion */            
    },
    mounted() {
      this.modulesActive = Session.getSession().auth.user.permissions.modules

      this.setup()
      this.getPHPCustom()
    }, 
    computed: {
      isCost() {
        var status = false
        if(this.modulesActive) {
          this.modulesActive.forEach(element => {
            if(element.id == Modules.COSTOS) {
              status = true
            }
          })          
        }
        return status
      },
      isContents() {
        var status = false
        if(this.modulesActive) {
          this.modulesActive.forEach(element => {
            if(element.id == Modules.CONTENIDOS) {
              status = true
            }
          })
        }
        return status
      },           
    },
    methods: {
      filterWidgetsMeta(widget) {
        const reference = widget.reference
        if(reference === 'pie_origen_marketplace_interested') {
          return this.parameters.haveMarketplace
        }
        if(reference === 'list_marketplace_message_send_interested') {
          return this.parameters.haveMarketplace
        }
        if(reference === 'list_products_with_stock_minimum' || reference === 'list_products_without_stock') {
          return !this.parameters.haveMarketplace
        }
        if(reference === 'list_sublines') {
          return this.parameters.haveLines
        }
        return true
      },
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      }, 
      
      openProducts() {
        this.$router.push({ name: 'ProductsStaffCrudProducts' })
      },
      
      openMarketplace() {
        this.$router.push({ name: 'ProductsStaffCrudProductsMarketplace' })
      },
      
      openProductsCompound() {
        this.$router.push({ name: 'ProductsStaffCrudProductsCompound' })
      },
        
      openLines() {
        this.$router.push({ name: 'ProductsStaffCrudLines' })
      },
      
      openCategories() {
        this.$router.push({ name: 'ProductsStaffCrudCategories' })
      },
      
      openColors() {
        this.$router.push({ name: 'ProductsStaffCrudColors' })
      },     

      openWaist() {
        this.$router.push({ name: 'ProductsStaffCrudWaist' })
      },

      openContactSold() {
        this.$router.push({ name: 'ProductsStaffSummaryContactSold' })
      },

      openUnitMeasurement() {
        this.$router.push({ name: 'ProductsStaffCrudUnitMeasurement' })
      },

      openProductsWeb() {
        this.$router.push({ name: 'ProductsStaffCrudProductsWeb'})
      },

      getPHPCustom() {
        ServicesPHP.obtenerPHPByModule(Modules.PRODUCTOS)
        .then((response) => {
          this.arr.PHPCustom = response.data       
        })
      },
      openPHPCustom(item) {
        this.$router.push({ name: 'ViewStaffViewPHPCustom', params: {id: item.id} })
      }      
    }    
   
  }
</script>

<style>

</style>
